<!--
	@name app-client-dashboard-workflow-sourcing
	@description Client Workflow Sourcing Item
	@date 2024/02/06
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<app-client-dashboard-workflow-template
			:workflow-item="workflowItem"
			@close-workflow-item="$emit('close-workflow-item')"
			@update-status="$emit('update-status', $event)"
		>
			<template slot="activity">
				<app-client-dashboard-workflow-sourcing-activity
					:client="client"
					:asset="asset"
					:association="association"
					:intro-resource="introResource"
					@toggle-intro-resource="toggleIntroResource"
					@workflow-updated="$emit('workflow-updated')"
				/>
			</template>

			<template v-if="site && (!('usesAirFlow' in site) || site.usesAirFlow)" slot="resources">
				<app-client-dashboard-workflow-template-resources :section="section" :resources="resources" :remove-intro-video="removeIntroVideo" />
			</template>
		</app-client-dashboard-workflow-template>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import AppClientDashboardWorkflowTemplate from '@/component/app/client/dashboard/workflow/template';
	import AppClientDashboardWorkflowSourcingActivity from '@/component/app/client/dashboard/workflow/sourcing/activity';
	import AppClientDashboardWorkflowTemplateResources from '@/component/app/client/dashboard/workflow/template/resources';
	import courseVideoMixin from '@/mixins/course-video';

	export default {
		name: 'app-client-dashboard-workflow-sourcing',

		components: {
			AppClientDashboardWorkflowTemplate,
			AppClientDashboardWorkflowSourcingActivity,
			AppClientDashboardWorkflowTemplateResources
		},

		mixins: [courseVideoMixin],

		props: {
			workflowItem: { type: Object, required: true },
			client: { type: Object, required: true },
			association: { type: Object, default: null },
			asset: { type: Object, required: true },
			resources: { type: Array, required: true }
		},

		data() {
			return {
				section: 'sourcing'
			};
		},

		computed: {
			...mapState('CmsSite', ['site'])
		}
	};
</script>

<style scoped lang="scss"></style>
